import { GeckoEditableFeature } from 'types/assetModel/features/baseClasses/geckoEditableFeature'
import { GeckoFeature } from 'types/assetModel/features/baseClasses/geckoFeature'
import { GeckoComponentRect } from 'types/geometric/geckoComponentRect'

export type SceneConfig = {
  config_2d?: {
    position: [number, number]
    rotation: number
  }
  config_3d?: {
    position: [number, number, number]
    rotation: [number, number, number]
  }
}

/**
 *
 */
export abstract class GeckoEditableComponent extends GeckoEditableFeature {
  id: string
  name: string
  json: Record<string, unknown>
  abstract componentBounds: GeckoComponentRect
  abstract features: Map<string, GeckoFeature>

  /**
   * Constructor for the base GeckoEditableComponent. This class should not
   * be instantiated on its own, but should be extended
   * @param id        The ID of the component
   * @param name      The human friendly name of the component
   * @param rawJSON   The raw JSON that was parsed to create the Asset Model Component
   */
  protected constructor(
    id: string,
    name: string,
    rawJSON: Record<string, unknown>
  ) {
    super(id)
    this.id = id
    this.name = name
    this.json = rawJSON
  }
}
